





















import Vue from "vue";
import { Worker } from "../../interfaces/Worker";
export default Vue.extend({
  props: {
    worker: {
      type: Object as () => Worker,
      required: true,
    },
  },
  computed: {
    name(): string {
      return `${this.worker.nativeWorker?.firstName || ""} ${this.worker.nativeWorker?.lastName || ""}`;
    },
    nihhi(): string {
      return `${this.worker.nihii || ""}`;
    },
    ssin(): string {
      return this.worker.nativeWorker?.ssin && this.worker.nativeWorker?.ssin != "0          "
        ? `${this.worker.nativeWorker.ssin.substr(0, 2)}.${this.worker.nativeWorker.ssin.substr(
            2,
            2
          )}.${this.worker.nativeWorker.ssin.substr(4, 2)}-${this.worker.nativeWorker.ssin.substr(
            6,
            3
          )}.${this.worker.nativeWorker.ssin.substr(9, 2)}`
        : "";
    },
    iban(): string {
      return this.worker.foreignBankAccount?.iban
        ? `${this.worker.foreignBankAccount.iban.substr(0, 4)} ${this.worker.foreignBankAccount.iban.substr(
            4,
            4
          )} ${this.worker.foreignBankAccount.iban.substr(8, 4)} ${this.worker.foreignBankAccount.iban.substr(12, 4)}`
        : "";
    },
    address1(): string {
      return `${this.worker.address?.streetName || "..."}, ${this.worker.address?.streetNr || "..."} ${this.worker.address?.streetBox || ""}`;
    },
    address2(): string {
      return `${this.worker.address?.postalCode || ""} ${this.worker.address?.municipality || ""}`;
    },
    cbe(): string {
      return `${this.worker.cbe || ""}`;
    },
  },
});
